var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNecklaceUnder = function SvgNecklaceUnder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 45,
    height: 26,
    viewBox: "0 0 1.07 0.62",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.42.06C.41.21.42.23.25.27.17.29.11.3.08.38.05.48.05.54.13.54.29.54.44.54.6.55c.09.01.27.01.35 0 .04 0 .05.02.06-.05C1.03.39.98.33.88.29.81.27.73.29.68.19A.425.425 0 0 1 .66.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.27.2C.26.24.36.31.41.33c.1.04.31.02.37-.1V.21"
  }))));
};

export default SvgNecklaceUnder;